import PageContainer from '@/components/ui/containers/PageContainer'
import { StatsContainer } from './StatsContainer'
import { useEstablishmentAuth } from '../model/useEstablishmentAuth'

export function StatisticsPage() {
  const { establishmentId, isSuperAdmin } = useEstablishmentAuth()

  if (!establishmentId) return null

  return (
    <PageContainer>
      <StatsContainer establishmentId={establishmentId} isSuperAdmin={isSuperAdmin} />
    </PageContainer>
  )
}
